import type { ComponentPropsWithoutRef, FC } from 'react';
import { getBaseActionClasses } from 'src/components/buttons-and-actions/button';
import { cn } from 'src/utils/cn';

export const RemoveButton: FC<
  ComponentPropsWithoutRef<'button'> & { error?: boolean }
> = ({ error, ...props }) => {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        getBaseActionClasses({}),
        `
          h-full appearance-none border-none bg-transparent p-0
          text-foreground-surface-default
          focus-visible:spaced-focus-style
          legacy:text-legacy-brand
        `,
        error &&
          `
            border-border-support-error-subdued
            bg-background-support-error-minimal text-foreground-support-error
            legacy:border-legacy-error legacy:bg-legacy-error-lighter
            legacy:text-legacy-error
          `,
        props.disabled
          ? `
            pointer-events-none cursor-not-allowed
            border-border-surface-disabled bg-background-surface-disabled
            text-foreground-surface-disabled
            legacy:border-legacy-inactive legacy:bg-legacy-inactive-lighter
            legacy:text-legacy-inactive
          `
          : `
            hover:text-foreground-secondary-hover
            hover:legacy:text-legacy-brand-secondary
          `,
        props.className
      )}
    />
  );
};
